import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// old links like /#/pricing keep working: turn them into real paths before the router starts
if (location.pathname === '/' && /^#\/[^#]/.test(location.hash)) history.replaceState(null, '', location.hash.slice(1));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
